(function () {
  if (window.__cartEtaInit) return;
  window.__cartEtaInit = true;

  var DAYS_LONG = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
  var extra = now.getHours() >= 12 ? 1 : 0;

  function addBusinessDays(date, days) {
    var r = new Date(date);
    var added = 0;
    while (added < days) {
      r.setDate(r.getDate() + 1);
      if (r.getDay() !== 0 && r.getDay() !== 6) added++;
    }
    return r;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function formatDate(d) {
    return DAYS_LONG[d.getDay()] + ', ' + pad(d.getDate()) + '/' + pad(d.getMonth() + 1);
  }

  function formatRange(d1, d2) {
    if (d1.getTime() === d2.getTime()) return formatDate(d1);
    return formatDate(d1) + ' - ' + formatDate(d2);
  }

  function parseDays(raw) {
    if (!raw) return null;
    var nums = raw.match(/\d+/g);
    if (!nums || !nums.length) return null;

    var isHours = raw.toLowerCase().indexOf('hora') !== -1;
    var min = parseInt(nums[0], 10);
    var max = nums.length > 1 ? parseInt(nums[1], 10) : min;
    if (isHours) { min = Math.ceil(min / 24); max = min + 1; }
    return { min: min, max: max };
  }

  function getShippingRange() {
    var script = document.getElementById('cart-shipping-meta');
    if (!script) return null;

    var meta;
    try { meta = JSON.parse(script.textContent); } catch (e) { return null; }

    var minDays = Infinity;
    var maxDays = 0;

    meta.forEach(function(item) {
      var parsed = parseDays(item.tiempo_envio);
      if (!parsed) return;
      if (parsed.min < minDays) minDays = parsed.min;
      if (parsed.max > maxDays) maxDays = parsed.max;
    });

    if (minDays === Infinity || maxDays === 0) return null;
    if (minDays === maxDays) maxDays = maxDays + 1;
    return { minDays: minDays, maxDays: maxDays };
  }

  function renderEta() {
    var target = document.getElementById('cart-eta-text');
    if (!target) return;

    var range = getShippingRange();
    if (!range) { target.textContent = '—'; return; }

    var minDate = addBusinessDays(now, range.minDays + extra);
    var maxDate = addBusinessDays(now, range.maxDays + extra);

    target.textContent = formatRange(minDate, maxDate);
  }

  function setupObserver() {
    var cartEl = document.querySelector('#main-cart-items');
    if (!cartEl || cartEl.__cartEtaObserver) return;

    var debounceTimer;
    var mo = new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(renderEta, 200);
    });
    mo.observe(cartEl, { childList: true, subtree: true });
    cartEl.__cartEtaObserver = mo;
  }

  function init() {
    renderEta();
    setupObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
